import { render, staticRenderFns } from "./worldmap.vue?vue&type=template&id=12a62f68"
import script from "./worldmap.vue?vue&type=script&lang=js"
export * from "./worldmap.vue?vue&type=script&lang=js"
import style0 from "./worldmap.vue?vue&type=style&index=0&id=12a62f68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports